<template>
  <div class="container">
    <div class="big_contaier">
      <div class="one_box">在线咨询</div>
      <div class="two_box">
        <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
          <el-form-item label="姓名">
            <el-input v-model="sizeForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="11"
              v-model="sizeForm.phone"
            ></el-input>
          </el-form-item>
          <el-form-item label="详细需求" prop="desc">
            <el-input type="textarea" v-model="sizeForm.title"></el-input>
          </el-form-item>
          <el-form-item size="large">
            <el-button @click="qv_xiao">取消</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { AMessages } from "@/common/js/api";
export default {
  name: "ZiXun",
  data() {
    return {
      labelPosition: "left",
      sizeForm: {
        member_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        phone: "",
        title: "",
      },
    };
  },
  created() {},
  methods: {
    qv_xiao() {
      this.sizeForm = {};
    },
    onSubmit() {
      AMessages(this.sizeForm)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$router.push({
              path: "/GaoDetail",
              query: {
                ids: localStorage.getItem("id"),
              },
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 50px;
  line-height: 50px;
}
/deep/ .el-form-item__label {
  text-align: left;
}
.container {
  background-color: #f8f9fa;

  z-index: 99;
  width: 100%;
  height: auto;
  overflow: hidden;
}
.big_contaier {
  margin: 60px auto;
  width: 1200px;
  height: 565px;
  line-height: 20px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 100);
  .one_box {
    color: rgba(56, 146, 235, 100);
    font-size: 20px;
    margin: 30px auto;
    width: 754px;
    text-align: left;
    border-bottom: 1px solid rgba(56, 146, 235, 100);
    padding-bottom: 10px;
  }
  .two_box {
    margin: 0px auto;
    width: 754px;
  }
}
</style>